import { defineAsyncComponent } from 'vue'
export default {
  blank: defineAsyncComponent(() => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/layouts/blank.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/home/jenkins/agent/workspace/nhegui-offcial-website-ui_master/app/layouts/default.vue").then(m => m.default || m))
}